import React, {Component} from 'react';

export default class ChannelsEnableBackupScreen extends Component {
    render() {
        let type = this.props.type;

        return(
            <div className='channels-enable-backup-screen'>
                <img src={type === 'messenger' ? '/img/channels/messenger-icon.svg' : type === 'webpush' ? '' +
                    '/img/channels/notification-icon.svg' : type === 'sms' ? '/img/channels/sms-icon.svg' : '/img/channels/viber-icon.svg'}/>
                <p className='text'>{this.props.text}</p>
                {this.props.buttonElement}
            </div>
        )
    }
}